export const auctionEntryStatus: Record<string, string> = {
  pending: 'Pendente',
  in_progress: 'Em andamento',
  completed: 'Finalizado',
  canceled: 'Cancelado',
}
